/* Header search dropdown: #mm-search in sections/pdp-header.liquid.
   The search icon opens a panel under the header instead of going to /search.
   Typing fetches sections/predictive-search.liquid through Shopify's predictive
   search endpoint, so results arrive as server-rendered shop-product-cards with
   the same image, price and quick-add as the collection grid. pdp-trimmer.js
   owns the add-to-cart click; manmade-bundle-price.js applies Kaching prices. */
(function () {
  'use strict';
  var panel = document.getElementById('mm-search');
  var toggle = document.querySelector('[data-mm-search-toggle]');
  if (!panel || !toggle) return;

  var form = panel.querySelector('form');
  var input = panel.querySelector('input[name="q"]');
  var box = panel.querySelector('.mm-psearch__box');
  var results = panel.querySelector('[data-mm-search-results]');
  var status = panel.querySelector('[data-mm-search-status]');
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var MIN = 2;
  var cache = {};
  var isOpen = false, timer = 0, ctrl = null, tracked = '';

  /* Fit the panel to the room left below the header. The CSS cap assumes the
     header sits at the top, but at page top the announcement bar is above it. */
  function fit() {
    box.style.maxHeight = Math.max(240, window.innerHeight - panel.getBoundingClientRect().top - 12) + 'px';
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    panel.hidden = false;
    fit();
    toggle.setAttribute('aria-expanded', 'true');
    input.focus(); // in the tap itself, so phones raise the keyboard
    void panel.offsetWidth; // start the fade from the hidden state
    panel.classList.add('is-open');
  }

  function close(refocus) {
    if (!isOpen) return;
    isOpen = false;
    commit();
    panel.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    setTimeout(function () { if (!isOpen) panel.hidden = true; }, 200);
    if (refocus) toggle.focus();
  }

  /* One Search event per term the shopper settles on (Enter, picking a
     result, or closing the panel), not one per keystroke. */
  function commit() {
    var term = input.value.trim();
    if (term.length < MIN || term === tracked) return;
    tracked = term;
    if (window.MMTracking && MMTracking.search) MMTracking.search(term);
  }

  function show(html) {
    results.innerHTML = html;
    results.removeAttribute('aria-busy');
    var res = results.querySelector('[data-mm-count]');
    var n = res ? parseInt(res.getAttribute('data-mm-count'), 10) || 0 : 0;
    panel.setAttribute('data-state', n ? 'results' : 'empty');
    status.textContent = res ? res.getAttribute('data-mm-status') : '';
    if (n && window.mmBundlePriceRefresh) window.mmBundlePriceRefresh();
  }

  function run(term) {
    clearTimeout(timer);
    if (ctrl) { ctrl.abort(); ctrl = null; }
    if (term.length < MIN) {
      results.innerHTML = '';
      results.removeAttribute('aria-busy');
      status.textContent = '';
      panel.setAttribute('data-state', 'idle');
      return;
    }
    if (Object.prototype.hasOwnProperty.call(cache, term)) { show(cache[term]); return; }

    results.setAttribute('aria-busy', 'true');
    ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var url = ROOT + 'search/suggest?q=' + encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=10' +
      '&resources[options][unavailable_products]=last' +
      '&section_id=predictive-search';
    fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var sec = doc.getElementById('shopify-section-predictive-search');
        if (!sec) throw new Error('no section');
        cache[term] = sec.innerHTML;
        if (input.value.trim() === term) show(cache[term]);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (input.value.trim() !== term) return;
        results.removeAttribute('aria-busy');
        results.innerHTML = '<p class="mm-psearch__msg">' + panel.getAttribute('data-mm-error') + '</p>';
        status.textContent = panel.getAttribute('data-mm-error');
        panel.setAttribute('data-state', 'empty');
      });
  }

  toggle.addEventListener('click', function (e) {
    e.preventDefault();
    if (isOpen) close(false); else open();
  });

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var term = input.value.trim();
    timer = setTimeout(function () { run(term); }, term.length < MIN ? 0 : 220);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    run(input.value.trim());
    commit();
    // Phones: drop the keyboard so the results underneath are visible.
    if (window.matchMedia && matchMedia('(hover: none)').matches) input.blur();
  });

  panel.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-mm-search-close]')) { close(true); return; }
    var chip = t.closest('[data-mm-search-term]');
    if (chip) {
      input.value = chip.getAttribute('data-mm-search-term');
      run(input.value.trim());
      input.focus();
      return;
    }
    if (t.closest('.mm-pcard a, .mm-pcard button')) {
      commit();
      // A quick add opens the cart drawer (pdp-trimmer.js), so get out of its way.
      if (t.closest('[data-mm-action="quick-add"]')) close(false);
    }
  });

  window.addEventListener('resize', function () { if (isOpen) fit(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) close(true);
  });

  document.addEventListener('click', function (e) {
    if (isOpen && !panel.contains(e.target) && !toggle.contains(e.target)) close(false);
  });
})();
